<div
    class="agpr-coverageInsightMentionCard"
    [class.agpr-coverageInsightMentionCard--selected]="mention.selected"
>
    <div
        class="agpr-coverageInsightMentionCard-checkbox"
    >
        <agpr-checkbox
            [id]="index !== undefined ? id + '_mentionCheckbox_' + index : id + '_mentionCheckbox'"
            [binary]="true"
            [(ngModel)]="mention.selected"
            (ngModelChange)="toggleSelect()"
            (click)="preventPropagation($event)"
        ></agpr-checkbox>
    </div>
    <div
        class="agpr-coverageInsightMentionCard-column"
    >
        <div
            *ngIf="(mention?.showTranslated && mention?.translation) ||
                (mention?.translation?.failedToTranslate) ||
                (mention?.isTranslatedPreferred && mention?.translation)"
            class="agpr-coverageInsightMentionCard-showTranslated"
        >
            <agpr-mention-language-display
                [mention]="mention"
                [showLanguageLabel]="true"
            ></agpr-mention-language-display>
        </div>
        <div class="agpr-coverageInsightMentionCard-headlineRow">
            <div class="agpr-coverageInsightMentionCard-headline">
                @if(mention.url) {
                    <a
                        [id]="id + '.sourceLink'"
                        [href]="mention.url"
                        target="_blank"
                        class="agpr-coverageInsightMentionCard-link"
                        (click)="preventPropagation($event)"
                    >
                        @if ((mention?.showTranslated || mention?.isTranslatedPreferred) && mention?.translation?.headline) {
                            <span class="agpr-coverageInsightMentionCard-headlineValue" dir="auto" [innerHTML]="mention?.translation?.headline"></span>
                        } @else {
                            <span class="agpr-coverageInsightMentionCard-headlineValue" dir="auto" [innerHTML]="mention.headline ? mention.headline : mention.mediaType.noHeadlineMessage | localize"></span>
                        }
                    </a>
                } @else if (mention.headline) {
                    @if ((mention?.showTranslated || mention?.isTranslatedPreferred) && mention?.translation?.headline) {
                        <span class="agpr-coverageInsightMentionCard-headlineValue" dir="auto" [innerHTML]="mention?.translation?.headline"></span>
                    } @else {
                        <span class="agpr-coverageInsightMentionCard-headlineValue" dir="auto" [innerHTML]="mention.headline"></span>
                    }
                } @else {
                    <span class="agpr-coverageInsightMentionCard-headlineValue">{{ mention.mediaType.noHeadlineMessage | localize }}</span>
                }
            </div>
            <div class="agpr-coverageInsightMentionCard-mediaType">
                <span
                    role="img"
                    [ngClass]="mention.mediaType.icon"
                    [agprTooltip]="mention.mediaType.tooltip"
                    tooltipPosition="left"
                ></span>
            </div>
        </div>


        <div class="agpr-coverageInsightMentionCard-outletAuthorContainer">
            @if(mention.publication?.name) {
                <div class="agpr-coverageInsightMentionCard-outletRow">
                    <div class="agpr-coverageInsightMentionCard-outlet">
                        @if (isLegacyTargetingUser) {
                            <a
                                class="agpr-coverageInsightMentionCard-link"
                                [id]="id + '.publicationLink'"
                                *ngIf="mention.publication.outletUrl && isLegacyTargetingUser; else pubNameLegacy"
                                [href]="mention.publication.outletUrl"
                                target="_blank"
                            >
                                <ng-container *ngTemplateOutlet="pubNameLegacy"></ng-container>
                            </a>
                            <ng-template #pubNameLegacy>
                                <span>{{ mention.publication?.name }}</span>
                            </ng-template>
                        } @else {
                            <agpr-button
                                *ngIf="mention.publication?.uuid; else pubName"
                                [style]="buttonTypes.link"
                                class="agpr-coverageInsightMentionCard-link agpr-coverageInsightMentionCard-link-profile"
                                [id]="id + '.publicationLink'"
                                (click)="outletClick($event)"
                                agprTooltip="Mention.tooltip.outlet"
                                tooltipPosition="top"
                            >
                                <ng-container *ngTemplateOutlet="pubName"></ng-container>
                            </agpr-button>
                            <ng-template #pubName>
                                <!-- please do not change the indent here, it would add an empty space -->
                                <span id="outletName">
                                    {{ mention.publication?.name }}<span id="outletNameIcon" class="agpr-coverageInsightMentionCard-link-profile-hoverIcon fa-kit fa-agpr-outlet-solid"></span>
                                </span>
                            </ng-template>
                        }
                    </div>
                    <span class="agpr-influencerStream-card-timestamp">
                        {{ mention.relativeDateString }}
                    </span>
                </div>
            }

            @if (mention.author.name) {
                <div class="agpr-coverageInsightMentionCard-authorRow">
                    <div class="agpr-coverageInsightMentionCard-author">
                        <span>{{ mention.isRetweet ? ('Mention.RetweetedBy' | localize) : "" }}</span>
                        <span>{{ mention.isTweetReply ? ('Mention.TweetReply' | localize) : "" }}</span>
                        <span>{{ mention.linkedinData?.type === linkedinTypeEnum.REPOST ? ('Mention.RetweetedBy' | localize) : "" }}</span>
                        @if (isLegacyTargetingUser) {
                            <a
                                class="agpr-coverageInsightMentionCard-link"
                                [id]="id + '.authorLink'"
                                *ngIf="mention.author.contactUrl; else authorNameLegacy"
                                [href]="mention.author.contactUrl"
                                target="_blank"
                            >
                                <ng-container *ngTemplateOutlet="authorNameLegacy"></ng-container>
                            </a>
                            <ng-template #authorNameLegacy>
                                <span>{{ mention.author?.name }}</span>
                            </ng-template>
                        } @else {
                            <agpr-button
                                *ngIf="mention.author?.uuid; else contactName"
                                class="agpr-coverageInsightMentionCard-link agpr-coverageInsightMentionCard-link-profile"
                                [id]="id + '.authorLink'"
                                [style]="buttonTypes.link"
                                (click)="contactClick($event)"
                                agprTooltip="Mention.tooltip.contact"
                                tooltipPosition="top"
                            >
                                <ng-container *ngTemplateOutlet="contactName"></ng-container>
                            </agpr-button>
                            <ng-template #contactName>
                                <!-- please do not change the indent here, it would add an empty space -->
                                <span id="contactName">
                                    <span *ngIf="mention.mediaType.id === mediaTypeEnum.TWITTER && !mention.author.id">&#64;</span>{{ mention.author?.name }}<span id="contactNameIcon" class="agpr-coverageInsightMentionCard-link-profile-hoverIcon fa-solid fa-user"></span>
                                </span>
                            </ng-template>
                        }
                    </div>
                    @if (!mention.publication?.name) {
                        <span class="agpr-influencerStream-card-timestamp">
                            {{ mention.relativeDateString }}
                        </span>
                    }
                </div>
            }
            @if(!mention.publication?.name && !mention.author.name) {
                <div class="agpr-coverageInsightMentionCard-flexBox">
                    <div class="agpr-coverageInsightMentionCard-spacer"></div>
                    <span class="agpr-influencerStream-card-timestamp">
                        {{ mention.relativeDateString }}
                    </span>
                </div>
            }
        </div>
        <div class="agpr-coverageInsightMentionCard-mentionBody">
            @if ((mention?.showTranslated || mention?.isTranslatedPreferred) && mentionBody) {
                <span
                    [innerHTML]="
                        ((mention?.summary )
                            ? mention?.translation?.summary : mention?.translation?.body
                            | indexHighlight : mention?.translation?.bodyHighlightIndexes : highlightKeywords
                            | mentionLinks : mention.mediaType.id
                            | indexHighlightSup
                            | filterStringByIndex : (mention.summary ? mention?.translation?.summaryHighlightIndexes?.[0] : mention?.translation?.bodyHighlightIndexes?.[0]) : 30
                        )
                    "
                ></span>
            } @else {
                <span
                    [innerHTML]="mentionBody
                    | mentionLinks:mention.mediaType.id
                    | indexHighlightSup
                    | filterStringByIndex: mention.contexualKeywordIndices[0]: 30"
                >
                </span>
            }
        </div>

        <div
            class="agpr-coverageInsightMentionCard-imageContainer"
            *ngIf="mention.images.length > 0"
        >
            @if (mention.images[0].source) {
                <img
                    class="agpr-coverageInsightMentionCard-image"
                    [src]="mention.images[0].source"
                    [alt]="'Mention.image.alt' | localize"
                    (error)="mention.images[0].source=undefined"
                />
            }
        </div>
    </div>
    <div class="agpr-coverageInsightMentionCard-contextualButtons">
        <agpr-button
            [style]="buttonTypes.contextMenu"
            tooltip="Social.intelligence.themeManagement.themeCard.viewTheme.tooltip"
            tooltipPosition="left"
            icon="fa-regular fa-duotone fa-eye"
            (click)="viewMention.emit()"
        ></agpr-button>
        <agpr-button
            [style]="buttonTypes.contextMenu"
            icon="fa-regular fa-duotone fa-gear"
            agprTooltip="Mention.manageMentionOrganization.gearIcon.tooltip"
            tooltipPosition="top"
            (click)="manageMention.emit()"
        ></agpr-button>
        @if(openAiPermission &&
            !mention.isTranslatedPreferred &&
            !mention.isFinancialTimes &&
            mention?.languageModel?.name &&
            ((mention?.languageModel?.name | localize) !== userLanguage)) {
            <agpr-button
                [id]="'quick-translate' + mention?.id"
                [icon]="mention.translating ? '' : 'fa-kit-duotone fa-agpr-translate'"
                [style]="buttonTypes.contextMenu"
                class="agpr-mentionList-icon agpr-mentionList-icon--topRight"
                [disabled]="concurrentTranslation >= maxConcurrentTranslation"
                [ngClass]="{
                    'agpr-mentionList-icon-show': mention.translating
                }"
                [tooltip]="(concurrentTranslation >= maxConcurrentTranslation) ?
                    ('Mention.translate.tooManyRequests' | localize : {
                        max : maxConcurrentTranslation
                    }) :
                    ('Mention.translateTo' | localize: {
                        language: mention?.showTranslated ? ('Language.' + mention?.language | localize) : userLanguage
                    })
                "
                tooltipPosition="top"
                (click)="mention?.showTranslated ? revertTranslate(mention) : translate(mention)"
                [loading]="mention.translating"
            >
            </agpr-button>
        }
    </div>
</div>
